import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

import useParts from "../../hooks/useParts";
import { toast } from "react-toastify";

const ManageParts = () => {
  const [carParts, setCarParts] = useParts([]);
  const [items, setItems] = useState([]);
  const [itemsPrice, setItemsPrice] = useState([]);

  //--------- Update Quantity-----------
  const handleInputChange = (event, index) => {
    const { value } = event.target;
    // console.log({ value });
    const updatedCarParts = [...carParts];
    updatedCarParts[index].quantity = value;
    setCarParts(updatedCarParts);
  };

  const handleUpdateQuantity = (id) => {
    const foundItem = carParts.filter((product, index) => product._id === id);
    // console.log("foundItem", foundItem[0]);
    setItems(foundItem);
    const url = `https://mbababd24.onrender.com/part/${id}`;
    fetch(url, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(foundItem[0]),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("success", data);
        toast("Quantity Update successfully!!!");
      });
  };
  console.log(items);

  //--------- Update Price-----------
  const handleInputChangePrice = (event, index) => {
    const { value } = event.target;
    console.log({ value });
    const updatedProducePrice = [...carParts];
    updatedProducePrice[index].price = value;
    setCarParts(updatedProducePrice);
  };

  const handleUpdatePrice = (id) => {
    const foundNewItemPrice = carParts.filter(
      (product, index) => product._id === id
    );
    console.log("foundItem price", foundNewItemPrice[0]);
    setItemsPrice(foundNewItemPrice);
    console.log("success price update id: ", id);
    const url = `https://mbababd24.onrender.com/priceUpdate/${id}`;
    fetch(url, {
      method: "PUT",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(foundNewItemPrice[0]),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("success price update: ", data);
        toast("Price Update successfully!!!");
      });
  };
  console.log(itemsPrice);

  //----------Delete Products----------
  const handleDelete = (id) => {
    const proceed = window.confirm("Are you sure?");
    if (proceed) {
      const url = `https://mbababd24.onrender.com/part/${id}`;
      fetch(url, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          const remaining = carParts.filter((carPart) => carPart._id !== id);
          setCarParts(remaining);
        });
    }
  };

  return (
    <div class="overflow-x-auto">
      <table class="table table-zebra w-full">
        <thead>
          <tr>
            <th>Index</th>
            <th>Picture</th>
            <th>Name</th>
            <th>Price</th>
            <th>Update Price</th>
            <th>Quantity</th>
            <th>Update Quantity</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {carParts.map((carPart, index) => (
            <tr key={index} carPart={carPart}>
              <td className="w-1">{index + 1}</td>
              <td className="w-2">
                <div class="avatar">
                  <div class="rounded-xl">
                    <img className="w-16" src={carPart.img} alt="pic" />
                  </div>
                </div>
              </td>
              <td className="w-2 p-0">{carPart.name.slice(0, 15)}..</td>
              <td className="w-4">{carPart.price}</td>
              <td className="w-4">
                <div>
                  <div>
                    <input
                      className="input input-bordered input-sm w-28 max-w-xs"
                      placeholder="Enter Number"
                      type="text"
                      onChange={(event) => handleInputChangePrice(event, index)}
                    />
                  </div>

                  <div className="mt-2">
                    <button
                      onClick={() => handleUpdatePrice(carPart._id)}
                      className="btn btn-sm bg-secondary shadow-2xl border-2 border-neutral max-w-xs capitalize hover:bg-primary"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </td>
              <td className="w-4">{carPart.quantity}</td>
              <td className="w-10">
                <div>
                  <div>
                    <input
                      className="input input-bordered input-sm w-28 max-w-xs"
                      placeholder="Enter Number"
                      type="text"
                      onChange={(event) => handleInputChange(event, index)}
                    />
                  </div>

                  <div className="mt-2">
                    <button
                      onClick={() => handleUpdateQuantity(carPart._id)}
                      className="btn btn-sm bg-secondary shadow-2xl border-2 border-neutral max-w-xs capitalize hover:bg-primary"
                    >
                      Update
                    </button>
                  </div>
                </div>
              </td>
              <td className="w-4">
                <button
                  onClick={() => handleDelete(carPart._id)}
                  class="btn btn-outline btn-sm btn-neutral"
                >
                  <FontAwesomeIcon className="delete-icon" icon={faTrash} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManageParts;
